/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { PatientDto } from './patient-dto';
import { PatientSeizureTypeDto } from './patient-seizure-type-dto';

/**
 * 
 * @export
 * @interface MedicalEventDto
 */
export interface MedicalEventDto {
    /**
     * 
     * @type {number}
     * @memberof MedicalEventDto
     */
    'consultationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof MedicalEventDto
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof MedicalEventDto
     */
    'durationSeconds'?: number;
    /**
     * 
     * @type {number}
     * @memberof MedicalEventDto
     */
    'eventCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof MedicalEventDto
     */
    'eventType'?: MedicalEventDtoEventTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof MedicalEventDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof MedicalEventDto
     */
    'metadata'?: string;
    /**
     * 
     * @type {string}
     * @memberof MedicalEventDto
     */
    'occurrenceTime'?: string;
    /**
     * 
     * @type {PatientDto}
     * @memberof MedicalEventDto
     */
    'patient'?: PatientDto;
    /**
     * 
     * @type {PatientSeizureTypeDto}
     * @memberof MedicalEventDto
     */
    'patientSeizureType'?: PatientSeizureTypeDto;
}

/**
    * @export
    * @enum {string}
    */
export enum MedicalEventDtoEventTypeEnum {
    Seizure = 'SEIZURE',
    Menstruation = 'MENSTRUATION',
    Infection = 'INFECTION',
    SleepDeprivation = 'SLEEP_DEPRIVATION',
    Fever = 'FEVER',
    PregnancyOrPrePregnancyPeriodStart = 'PREGNANCY_OR_PRE_PREGNANCY_PERIOD_START',
    PregnancyOrPrePregnancyPeriodEnd = 'PREGNANCY_OR_PRE_PREGNANCY_PERIOD_END',
    VnsStimulatorImplantation = 'VNS_STIMULATOR_IMPLANTATION',
    Other = 'OTHER'
}


